<template>
    <div class="landing landing-section" id="home">
        <div class="container content-wrapper d-flex align-items-center justify-content-center">
            <div class="content d-flex align-items-center flex-column">
                <h1 class="hero-title">We create<br>something with<br>anything</h1>
                <button class="btn btn-cta-secondary mt-3" @click="contactUsOpen">Request an estimate</button>
                <div class="scroll-indicator d-flex flex-column">
                    <img src="@/assets/icons/scroll-down.svg" alt="Scroll down">
                    <img src="@/assets/icons/scroll-down.svg" alt="Scroll down">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Landing',
        methods: {
            contactUsOpen($event) {
                this.$emit('contact-us-click', $event)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/styles/variables/variables';

    .landing {

        .content-wrapper {
            height: 100vh;
            min-height: 600px;

            .content {
                .hero-title {
                    text-align: center;
                }

                .scroll-indicator {
                    padding-top: 12vh;

                    :first-child, :last-child {
                        opacity: .3;
                        animation-name: breathing-opacity;
                        animation-duration: 5s;
                        animation-iteration-count: infinite;
                        animation-play-state: running;
                    }

                    :first-child {
                        animation-delay: 0s;
                    }

                    :last-child {
                        animation-delay: 100ms;
                    }
                }
            }
        }
    }

    /* Animations */
    @keyframes breathing-opacity {
        0% {
            opacity: .3;
        }
        10% {
            opacity: 1;
        }
        20% {
            opacity: .3;
        }
        100% {
            opacity: .3;
        }
    }

    @media all and (max-width: 800px) {
        .hero-title {
            font-size: 8vw;
        }
    }
</style>
